import { z } from 'zod';
/**
 * Installed App Schema
 * Represents an app installed for a specific tenant (stored in Organization.apps[])
 */ export const InstalledAppSchema = z.object({
    appId: z.string(),
    enabled: z.boolean().default(false),
    /**
   * The superadmin's switch: whether the tenant may use the app at all,
   * independent of the system admin's `enabled`. Plainly optional rather than
   * defaulted — ABSENT MEANS ALLOWED, and the org-serializing paths return raw
   * docs (see `ManagedInstalledAppSchema`), so a Zod default would never run.
   * Every reader compares `allowed !== false`.
   */ allowed: z.boolean().optional()
});

//# sourceMappingURL=installed-app.schema.js.map